module.exports = __webpack_public_path__ + "img/clock_icon.15b417a1.jpg";